import React from 'react';
import { Box, Grid, Grow, Typography } from '@mui/material';
import SignInImg from 'Assets/Images/login.png'
import RegForm from './RegForm';

const ADDITIONAL_INFO = [
  `✓ Professional experts can list their skill set, expertise, and experience.`,
  `✓ Search from a public or private list of vetted Advisors for fiduciary services.`,
  `✓ Secure engagement using negotiated organization rate cards.`,
  `✓ AI assistance with deliverables.`,
];

const Advisor = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(to right, #041e42, #78a8e6)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        p: 2,
      }}
    >
      <Grid container spacing={0}>
        {/* Left Side */}
        <Grow in timeout={1000}>
          <Grid item xs={12} md={5} sx={{ color: 'white', p: 4, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
              PRIVATE WEALTH ADVISOR FIRM
            </Typography>
            <Typography variant="h5" gutterBottom>
              Trusted Advisory Service
            </Typography>
            <ul style={{ listStyle: 'none', paddingLeft: 0, lineHeight: 1.8 }}>
              {ADDITIONAL_INFO.map((info, index) => (
                <li key={index}>{info}</li>
              ))}
            </ul>

            <Box component="img" src={SignInImg} alt="illustration" sx={{ width: '60%', maxWidth: 400, mt: 4 }} />
          </Grid>
        </Grow>
        {/* Right Side */}
        <Grid item xs={12} md={7}>
          <RegForm />
        </Grid>
      </Grid>
    </Box>

  );
};

export default Advisor;
